import * as actionTypes from "./actions";
import config from "./../config";
import { isEmpty } from "lodash";

const pageInfo = {
  "total": 1,
  "page": 1,
  "pageSize": 20,
  "totalPage": 1,
  "offset": 0,
  "hasNext": false,
  "hasPrev": false
}

const initialState = {
  isOpen: [], //for active default menu
  isTrigger: [], //for active default menu, set blank for horizontal
  ...config,
  isFullScreen: false, // static can't change,
  isRequest: false,
  isError: false,
  isLogin: false,
  employees: Array.apply(null, Array(10)).map((_, i) => i),
  onlineInformation: [],
  isEmptyOnlineInformation: false,
  isUpdateWork: false,

  dataProduct: [],
  isProductRequest: false,

  dataCustomer: [],
  isCustomerRequest: false,
  dataReport: [],

  dataReportCustomer: [],
  isPostReportCustomer: false,

  dataReportStaff: [],
  isPostReportStaff: false,

  productData: [],
  isProduct: false,

  reportStaffCustomer: [],
  sumReportStaffCustomer: {
    TotalSaleAmount: 0,
    TotalSaleAmountReturn: 0,
    TotalDiscountAmount: 0,
    Sale: 0,
  },
  isRequestStaffCustomer: false,

  employeeReport: [],
  isEmployeeReport: false,
  isReportReQuest: false,
  employeeSelected: {},
  isApp: false,
  boundMap: null,
  workers: {
    members: [],
    permissions: [],
    products: [],
    provinces: [],
  },
  newWorkers: {
    members: [],
    permissions: [],
    products: [],
    provinces: [],
  },
  loginHistory: {
    data: [],
    pageInfo,
  },
  folderTree: [],
  isGetFileFolderTree: false,

  notification: {
    data: [],
    pageInfo,
  },
  notificationDetail: {},
  chartConfigDatabase: {
    data: [],
    pageInfo,
  },
  isChartConfigDatabase: false,
  chartConfigDatabaseDetail: {},
  infoTestChartConfigDatabase: {},
  customerGroups: [],
  productCategories: [],
  isProductCategories: false,
  organization: [],
  workerInfo: {},
  kpi: {},
  achieved: {},
  groupKpi: {},
};

const reducer = (state = initialState, action) => {
  let trigger = [];
  let open = [];

  switch (action.type) {
    case actionTypes.CUSTOMER_STAFF_CUSTOMER_POST:
      return{
        ...state,
        isRequestStaffCustomer: true,
        sumReportStaffCustomer: initialState.sumReportStaffCustomer,
      }
    case actionTypes.CUSTOMER_STAFF_CUSTOMER_SUCCESS:
      return{
        ...state,
        reportStaffCustomer: action.reportStaffCustomer,
        sumReportStaffCustomer: action.sumReportStaffCustomer,
      }
 
    case actionTypes.CUSTOMER_STAFF_PORT:
      return {
        ...state,
        isPostReportStaff: true,
      };
    case actionTypes.CUSTOMER_STAFF_PORT_SUCCESS:
      return {
        ...state,
        isPostReportStaff: false,
        dataReportStaff: action.dataReportStaff,
      };

    case actionTypes.IS_MOBILE_APP:
      return {
        ...state,
        isApp: true,
      };

    case actionTypes.PRODUCT_REQUEST:
      return {
        ...state,
        isProduct: true,
      };
    case actionTypes.PRODUCT_REQUEST_SUCCESS:
      return {
        ...state,
        isProduct: false,
        productData: action.productData,
      };
    case actionTypes.PRODUCT_GET:
      return {
        ...state,
        isProductRequest: true,
      };

    case actionTypes.PRODUCT_GET_SUCCESS:
      return {
        ...state,
        isProductRequest: false,
        dataProduct: action.dataProduct,
      };

    case actionTypes.CUSTOMER_REPORT_PORT:
      return {
        ...state,
        isPostReportCustomer: true,
      };

    case actionTypes.CUSTOMER_REPORT_PORT_SUCCESS:
      return {
        ...state,
        isPostReportCustomer: false,
        dataReportCustomer: action.dataReportCustomer,
      };

    case actionTypes.CUSTOMER_GET:
      return {
        ...state,
        isCustomerRequest: true,
      };

    case actionTypes.CUSTOMER_GET_SUCCESS:
      return {
        ...state,
        isCustomerRequest: false,
        dataCustomer: action.dataCustomer,
      };
    case actionTypes.REPORT_GET:
      return {
        ...state,
        isReportReQuest: true,
      };

    case actionTypes.REPORT_GET_SUCCESS:
      return {
        ...state,
        isReportReQuest: false,
        dataReport: action.dataReport,
      };

    case actionTypes.COLLAPSE_MENU:
      return {
        ...state,
        collapseMenu: !state.collapseMenu,
      };

    case actionTypes.COLLAPSE_MENU_OFF:
      return {
        collapseMenu: false,
      };
    case actionTypes.COLLAPSE_TOGGLE:
      if (action.menu.type === "sub") {
        open = state.isOpen;
        trigger = state.isTrigger;

        const triggerIndex = trigger.indexOf(action.menu.id);
        if (triggerIndex > -1) {
          open = open.filter((item) => item !== action.menu.id);
          trigger = trigger.filter((item) => item !== action.menu.id);
        }

        if (triggerIndex === -1) {
          open = [...open, action.menu.id];
          trigger = [...trigger, action.menu.id];
        }
      } else {
        open = state.isOpen;
        const triggerIndex = state.isTrigger.indexOf(action.menu.id);
        trigger = triggerIndex === -1 ? [action.menu.id] : [];
        open = triggerIndex === -1 ? [action.menu.id] : [];
      }

      return {
        ...state,
        isOpen: open,
        isTrigger: trigger,
      };
    case actionTypes.NAV_CONTENT_LEAVE:
      return {
        ...state,
        isOpen: open,
        isTrigger: trigger,
      };
    case actionTypes.NAV_COLLAPSE_LEAVE:
      if (action.menu.type === "sub") {
        open = state.isOpen;
        trigger = state.isTrigger;

        const triggerIndex = trigger.indexOf(action.menu.id);
        if (triggerIndex > -1) {
          open = open.filter((item) => item !== action.menu.id);
          trigger = trigger.filter((item) => item !== action.menu.id);
        }
        return {
          ...state,
          isOpen: open,
          isTrigger: trigger,
        };
      }
      return { ...state };
    case actionTypes.FULL_SCREEN:
      return {
        ...state,
        isFullScreen: !state.isFullScreen,
      };
    case actionTypes.FULL_SCREEN_EXIT:
      return {
        ...state,
        isFullScreen: false,
      };
    case actionTypes.CHANGE_LAYOUT:
      return {
        ...state,
        layout: action.layout,
      };
    case actionTypes.LOGIN_REQUESTED:
      return {
        ...state,
        isRequest: true,
        isError: false,
        isLogin: false,
        isUpdateWork: false,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isError: false,
        isLogin: true,
      };
    case actionTypes.LOGIN_FAIL:
      return {
        ...state,
        isRequest: false,
        isError: true,
        isLogin: false,
      };
    case actionTypes.EMPLOYEE_REQUESTED:
      return {
        ...state,
        isRequest: true,
        isError: false,
        isUpdateWork: false,
      };
    case actionTypes.EMPLOYEE_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isError: false,
        employees: action.employees,
      };
    case actionTypes.EMPLOYEE_FAIL:
      return {
        ...state,
        isRequest: false,
        isError: true,
      };
    case actionTypes.EMPLOYEE_ONLINE_INFORMATION_REQUESTED:
      return {
        ...state,
        isRequest: true,
        isError: false,
        isUpdateWork: false,
        isEmptyOnlineInformation: false,
        onlineInformation: [],
      };
    case actionTypes.EMPLOYEE_ONLINE_INFORMATION_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isError: false,
        boundMap: action.boundMap,
        onlineInformation: action.onlineInformation,
        isEmptyOnlineInformation: isEmpty(action.onlineInformation),
      };
    case actionTypes.EMPLOYEE_ONLINE_INFORMATION_FAIL:
      return {
        ...state,
        isRequest: false,
        isError: true,
        isEmptyOnlineInformation: false,
      };
    case actionTypes.EMPLOYEE_WORKER_REQUESTED:
      return {
        ...state,
        isRequest: true,
        isError: false,
        isUpdateWork: false,
        workers: {
          members: [],
          provinces: [],
          permissions: [],
          products: action?.isKeepData ? state.workers.products : [],
        },
        newWorkers: {
          members: [],
          provinces: [],
          permissions: [],
          products: action?.isKeepData ? state.newWorkers.products : [],
        },
      };
    case actionTypes.EMPLOYEE_WORKER_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isError: false,
        workers: action.workers,
        newWorkers: {
          members: action.workers.members.filter((item) => item.member),
          provinces: action.workers.provinces.filter((item) => item.status),
          permissions: action.workers.permissions.filter((item) => item.status),
          products: action.workers.products.filter((item) => item.status),
        },
      };
    case actionTypes.EMPLOYEE_WORKER_UPDATED:
      const { playground } = action;
      return {
        ...state,
        newWorkers: {
          ...state.newWorkers,
          [playground.key]: playground.data,
        },
      };
    case actionTypes.EMPLOYEE_WORKER_FAIL:
      return {
        ...state,
        isRequest: false,
        isError: true,
        workers: {
          members: [],
          provinces: [],
          permissions: [],
          products: [],
        },
        newWorkers: {
          members: [],
          provinces: [],
          permissions: [],
          products: [],
        },
      };
    case actionTypes.EMPLOYEE_WORKER_UPDATED_REQUESTED:
      return {
        ...state,
        isRequest: false,
        isError: false,
        isUpdateWork: false,
      };
    case actionTypes.EMPLOYEE_WORKER_UPDATED_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isError: false,
        isUpdateWork: true,
        employees: state.employees.map((item) => {
          if (item.Id === action.infoUpdate.id) {
            return {
              ...item,
              Amount: action.infoUpdate.amount
            }
          }
          return item;
        }),
        workers: action.workers,
        newWorkers: {
          members: action.workers.members.filter((item) => item.member),
          provinces: action.workers.provinces.filter((item) => item.status),
          permissions: action.workers.permissions.filter((item) => item.status),
          products: action.workers.products.filter((item) => item.status),
        },
      };
    case actionTypes.EMPLOYEE_WORKER_UPDATED_FAIL:
      return {
        ...state,
        isRequest: false,
        isError: true,
        isUpdateWork: false,
      };
    case actionTypes.EMPLOYEE_SELECTED:
      return {
        ...state,
        employeeSelected: {
          ...action.playground,
        },
      };
    case actionTypes.LOGIN_HISTORY_POST:
      return {
        ...state,
        isLoginHistoryRequest: true,
        isError: false,
        LoginHistory: [],
      };
    case actionTypes.LOGIN_HISTORY_SUCCESS: {
      return {
        ...state,
        isLoginHistoryRequest: false,
        isError: false,
        loginHistory: action.loginHistory,
      };
    }
    case actionTypes.LOGIN_HISTORY_FAIL:
      return {
        ...state,
        isLoginHistoryRequest: false,
        isError: true,
        LoginHistory: [],
      };
    case actionTypes.GET_FILE_FOLDER_TREE:
      return {
        ...state,
        isGetFileFolderTree: true,
        isError: false,
      };
    case actionTypes.GET_FOLDER_TREE_SUCCESS:
      return {
        ...state,
        isGetFileFolderTree: false,
        isError: false,
        folderTree: action.folderTree || [],
      };
    case actionTypes.GET_NOTIFICATION:
      return {
        ...state,
        isGetNotification: true,
        isError: false,
      };
    case actionTypes.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isGetNotification: false,
        isError: false,
        notification: action.notification,
      };
    case actionTypes.GET_NOTIFICATION_FAIL:
      return {
        ...state,
        isGetNotification: false,
        isError: true,
      };
    case actionTypes.GET_NOTIFICATION_DETAIL:
      return {
        ...state,
        isGetNotificationDetail: true,
        isError: false,
      };
    case actionTypes.GET_NOTIFICATION_DETAIL_SUCCESS:
      return {
        ...state,
        isGetNotificationDetail: false,
        isError: false,
        notificationDetail: action.notificationDetail,
      };
    case actionTypes.GET_NOTIFICATION_DETAIL_FAIL:
      return {
        ...state,
        isGetNotificationDetail: false,
        isError: true,
      };
    case actionTypes.POST_NOTIFICATION:
      return {
        ...state,
        isPostNotification: true,
        isError: false,
      };
    case actionTypes.POST_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isPostNotification: false,
        isError: false,
        notification: action.notification,
      };
    case actionTypes.POST_NOTIFICATION_FAIL:
      return {
        ...state,
        isPostNotification: false,
        isError: true,
      };

    case actionTypes.POST_FILE_MANAGER_FOLDER:
      return {
        ...state,
        isGetFileManagerFolder: true,
        isError: false,
      };
    case actionTypes.POST_FILE_MANAGER_FOLDER_SUCCESS:
      return {
        ...state,
        isGetFileManagerFolder: false,
        isError: false,
        fileManagerFolder: action.fileManagerFolder,
      };
    case actionTypes.GET_CONFIG_LOGO:
      return {
        ...state,
        isGetConfigLogo: true,
        isError: false,
      };
    case actionTypes.GET_CONFIG_LOGO_SUCCESS:
      return {
        ...state,
        isGetConfigLogo: false,
        isError: false,
        configLogo: action.configLogo,
      };
    case actionTypes.POST_SETUP_LOGO_SUCCESS:
      return {
        ...state,
        isGetConfigLogo: false,
        isError: false,
        configLogo: action.configLogo,
      };
    case actionTypes.POST_SETUP_LOGO:
      return {
        ...state,
        isGetConfigLogo: true,
        isError: false,
      };
    case actionTypes.GET_CHART_CONFIG_DATABASE:
      return {
        ...state,
        isChartConfigDatabase: true,
        isError: false,
      };
    case actionTypes.GET_CHART_CONFIG_DATABASE_SUCCESS:
      return {
        ...state,
        isChartConfigDatabase: false,
        isError: false,
        chartConfigDatabase: action.chartConfigDatabase,
      };
    case actionTypes.POST_CHART_CONFIG_DATABASE:
      return {
        ...state,
        isChartConfigDatabase: true,
        isError: false,
      };
    case actionTypes.POST_CHART_CONFIG_DATABASE_SUCCESS:
      return {
        ...state,
        isChartConfigDatabase: false,
        isError: false,
      };
    case actionTypes.PUT_CHART_CONFIG_DATABASE:
      return {
        ...state,
        isChartConfigDatabase: true,
        isError: false,
      };
    case actionTypes.PUT_CHART_CONFIG_DATABASE_SUCCESS:
      return {
        ...state,
        isChartConfigDatabase: false,
        isError: false,
      };
    case actionTypes.DELETE_CHART_CONFIG_DATABASE:
      return {
        ...state,
        isChartConfigDatabase: true,
        isError: false,
      };
    case actionTypes.DELETE_CHART_CONFIG_DATABASE_SUCCESS:
      return {
        ...state,
        isChartConfigDatabase: false,
        isError: false,
      };
    case actionTypes.GET_TEST_CONFIG_DATABASE:
      return {
        ...state,
        isTestChartConfigDatabase: true,
        isError: false,
      };
    case actionTypes.GET_TEST_CONFIG_DATABASE_SUCCESS:
      return {
        ...state,
        isTestChartConfigDatabase: false,
        isError: false,
        infoTestChartConfigDatabase: action.infoTestChartConfigDatabase,
      };
    case actionTypes.GET_TEST_CONFIG_DATABASE_FAIL:
      return {
        ...state,
        isTestChartConfigDatabase: false,
        isError: true,
      };
    case actionTypes.GET_CUSTOMER_GROUP:
      return {
        ...state,
        isGetCustomerGroups: true,
        isError: false,
      };
    case actionTypes.GET_CUSTOMER_GROUP_SUCCESS:
      return {
        ...state,
        isGetCustomerGroups: false,
        isError: false,
        customerGroups: action.customerGroups,
      };
    case actionTypes.GET_CUSTOMER_GROUP_FAIL:
      return {
        ...state,
        isGetCustomerGroups: false,
        isError: true,
      };
    case actionTypes.GET_PRODUCT_CATEGORY:
      return {
        ...state,
        isProductCategories: true,
        isError: false,
      };
    case actionTypes.GET_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        isProductCategories: false,
        isError: false,
        productCategories: action.productCategories,
      };
    case actionTypes.GET_PRODUCT_CATEGORY_FAIL:
      return {
        ...state,
        isProductCategories: false,
        isError: true,
      };
    case actionTypes.GET_ORGANIZATION:
      return {
        ...state,
        isGetOrganization: true,
        isError: false,
      };
    case actionTypes.GET_ORGANIZATION_SUCCESS:
      return {
        ...state,
        isGetOrganization: false,
        isError: false,
        organization: action.organization,
      };
    case actionTypes.GET_ORGANIZATION_FAIL:
      return {
        ...state,
        isGetOrganization: false,
        isError: true,
      };
    case actionTypes.PUT_SET_DATABASE_DEFAULT:
      return {
        ...state,
        isSetDatabaseDefault: true,
        isError: false,
      };
    case actionTypes.PUT_SET_DATABASE_DEFAULT_SUCCESS:
      return {
        ...state,
        isSetDatabaseDefault: false,
        isError: false,
      };
    case actionTypes.PUT_SET_DATABASE_DEFAULT_FAIL:
      return {
        ...state,
        isSetDatabaseDefault: false,
      };
    case actionTypes.GET_WORKER_INFO:
      return {
        ...state,
        isGetWorkerInfo: true,
        kpi: {},
        achieved: {},
        groupKpi: {},
        isError: false,
      };
    case actionTypes.GET_WORKER_INFO_SUCCESS:
      return {
        ...state,
        isGetWorkerInfo: false,
        isError: false,
        workerInfo: action.workerInfo,
        achieved: action.achieved,
        groupKpi: action.groupKpi,
      };
    case actionTypes.GET_WORKER_INFO_FAIL:
      return {
        ...state,
        isGetWorkerInfo: false,
        isError: true,
      };
    case actionTypes.UPDATE_PRODUCT_POSITION:
      return {
        ...state,
        isUpdateProductPosition: true,
        isError: false,
      };
    case actionTypes.UPDATE_PRODUCT_POSITION_SUCCESS:
      return {
        ...state,
        isUpdateProductPosition: false,
        isError: false,
      };
    
    case actionTypes.PUT_WORKER_INFO:
      return {
        ...state,
        isPutWorkerInfo: true,
        isError: false,
      };
    case actionTypes.PUT_WORKER_INFO_SUCCESS:
      return {
        ...state,
        isPutWorkerInfo: false,
        isError: false,
      };
    case actionTypes.PUT_WORKER_INFO_FAIL:
      return {
        ...state,
        isPutWorkerInfo: false,
        isError: true,
      };
    case actionTypes.UPDATE_KPI: {
      return {
        ...state,
        kpi: action.kpi,
        isError: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
